const B2C_CONFIG = {
    POLICY: process.env.REACT_APP_B2C_POLICY ?? "",
    REDIRECT_URI: `${window.location.origin}/${process.env.REACT_APP_B2C_LOGIN_REDIRECT_URI}`,
    POST_LOGOUT_REDIRECT_URI: `${window.location.origin}/${process.env.REACT_APP_B2C_LOGOUT_REDIRECT_URI}`,
};

export { B2C_CONFIG };
